import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import React, { Fragment } from 'react';

import { Dropdown, DropdownMenuItemType, IDropdownStyles, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { Icon } from 'office-ui-fabric-react/lib/Icon';

export default class PeoplePicker extends React.Component<any, any> {

  constructor(props: any) {
    super(props);

    this.state = {
      selectedUser: props.selectedUser,
      users: props.users
    };
  }

  render () {
    const dropdownStyles: Partial<IDropdownStyles> = {
      // dropdown: { width: 90 }
    };

    const options: IDropdownOption[] = this.state.users.map((user: any) => {
      return {
        key: user.PersonCode,
        text: user.UserName
      };
    });

    if (!this.state.selectedUser) {
      options.splice(0, 0, {
        key: 'none',
        text: 'Select Application Owner'
      });
    }

    return (
      <Dropdown
        options={options}
        onChange={(e, i) => this.handleDropdownChange(e, i)}
        onRenderPlaceholder={this._onRenderPlaceholder}
        onRenderTitle={this._onRenderTitle}
        placeholder="Select Application Owner"
        selectedKey={ this.state.selectedUser ? this.state.selectedUser.key : 'none' }
        styles={dropdownStyles}
      />
    );
  }

  private _onRenderTitle = (options: any): JSX.Element => {
    const option = options[0];

    return (
      <div>
        <Icon style={{ marginRight: '8px' }} iconName={'Contact'} aria-hidden="true" />
        <span>{option.text}</span>
      </div>
    );
  };

  private _onRenderPlaceholder = (props: any): JSX.Element => {
    return (
      <div className="dropdownExample-placeholder">
        <Icon style={{ marginRight: '8px' }} iconName={'Contact'} aria-hidden="true" />
        <span>{props.placeholder}</span>
      </div>
    );
  };

  private handleDropdownChange = async (event: any, item: any) => {
    this.setState({
      selectedUser: item
    });

    this.props.setUser(item);
  };
}
